import {CsvConfigJsonResult} from '../synoptic-configuration-csv-types';

export function isSensorIdentifier(obj: any): CsvConfigJsonResult {
  let valid = true;
  let errors = [];
  const validEntitiesType = ['deviceMeasurement', 'assetMeasurement', 'kpi'];
  if (obj.entityType === undefined) {
    errors.push({code: 'notExist', key: 'entityType'});
    valid = false;
  } else if (!validEntitiesType.includes(obj.entityType)) {
    errors.push({code: 'invalidValue', key: 'entityType', value: obj.entityType});
    valid = false;
  }

  if (obj.entityIdentifier === undefined) {
    errors.push({code: 'notExist', key: 'entityIdentifier'});
    valid = false;
  } else if (typeof obj.entityIdentifier !== 'string') {
    errors.push({code: 'notText', key: 'entityIdentifier', value: obj.entityIdentifier});
    valid = false;
  }

  if (obj.sensorName === undefined) {
    if(obj.entityType !== 'kpi'){
      errors.push({code: 'notExist', key: 'sensorName'});
      valid = false;
    }
  } else if (typeof obj.sensorName !== 'string') {
    errors.push({code: 'notText', key: 'sensorName', value: obj.sensorName});
    valid = false;
  }

  return {result: valid, errors: errors};
}
